import type { Hex } from "viem";
import { env } from "../env";
import { builderCodeDataSuffix } from "../builderCode";

/** Extra `sendUserOperation` options carrying this app's Base Builder Code, or nothing when none
 *  is configured. Spread into every user-operation call so all onchain activity is attributed. */
export function attributionOptions(): { dataSuffix?: Hex } {
  return env.VITE_BASE_BUILDER_CODE
    ? { dataSuffix: builderCodeDataSuffix(env.VITE_BASE_BUILDER_CODE) }
    : {};
}
